import { SxProps, Theme } from '@mui/material';

export const productCardTitleSX: SxProps<Theme> = () => ({
	color: '#2C2C2C',
	fontSize: {
		xs: 'var(--font-size-default)',
		sm: 'var(--font-size-body)',
	},
	fontWeight: '600',
	display: '-webkit-box',
	'-webkit-line-clamp': '2',
	'-webkit-box-orient': 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	textDecoration: 'none',
});

export const productCardCategorySX: SxProps<Theme> = () => ({
	color: '#505050',
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
	textDecoration: 'none',
});

export const productCardDescriptionSX: SxProps<Theme> = () => ({
	color: '#505050',
	fontSize: 'var(--font-size-small)',
	fontWeight: 'normal',
	mt: '5px',
	textDecoration: 'none',
});

export const productCardDiscountSX: SxProps<Theme> = {
	color: '#AB2326',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	marginRight: '8px',
	textDecoration: 'none',
};

export const productCardPriceSX = (hasDiscount: boolean): SxProps<Theme> => ({
	color: hasDiscount ? '#C2C2C2' : '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	textDecoration: hasDiscount ? 'line-through' : 'none',
});
